import {Component} from "@angular/core";

@Component({
  selector: 'app-other-country-label',
  templateUrl: './other.country.label.template.html',
  styleUrls: ['./other.country.label.style.scss']
})
export class OtherCountryLabelComponent  {

}
